import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConfigProvider } from 'antd';
import dayjs from 'dayjs';
import el from 'antd/locale/el_GR';
import 'dayjs/locale/el';
import 'antd/dist/reset.css';
import { store } from './store';
import reportWebVitals from './reportWebVitals';
import App from './App';

dayjs.locale('el');

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ConfigProvider locale={el}>
        <App />
      </ConfigProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
